import { Container } from './styles'
import reactIcon from '../../assets/react-icon.svg'
import linkedin from '../../assets/linkedin.svg'
import githubIcon from '../../assets/github.svg'
import whatsapp from '../../assets/whatsapp.svg'
//import telegram from '../../assets/telegram.svg'
import instagramIcon from '../../assets/instagram.svg'

export function Footer() {
  return (
    <Container className="footer">
      <a href="#home" className="logo">
        {/* 1. Ganti nama/logo Anda di sini */}
        <span>Sergio</span>
      </a>
      <div>
        <p>
          This Website was made with <img src={reactIcon} alt="React" />
        </p>
      </div>
      <div className="social-media">
        {/* 2. GANTI SEMUA LINK HREF DI BAWAH INI */}
        <a
          href="https://www.linkedin.com/in/masergio/" // Ganti dengan link LinkedIn Anda
          rel="noreferrer"
        >
          <img src={linkedin} alt="Linkedin" />
        </a>
        <a
          href="https://github.com/Baruls" // Ganti dengan link GitHub Anda
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>
        <a
          href="https://api.whatsapp.com/send/?phone=6283129133900&text=Hello+Sergio+I+found+your+contact+through+portfolio+site.%0A%0A" // Ganti dengan link WhatsApp Anda
          rel="noreferrer"
        >
          <img src={whatsapp} alt="Whatsapp" />
        </a>
        {/* <a
          href="YOUR_TELEGRAM_URL" // Ganti dengan link Telegram Anda
          target="_blank"
          rel="noreferrer"
        >
          <img src={telegram} alt="telegram" />
        </a> */}
        <a
          href="https://www.instagram.com/sergioreals" // Ganti dengan link Instagram Anda
          rel="noreferrer"
        >
          <img src={instagramIcon} alt="Instagram" />
        </a>
      </div>
    </Container>
  )
}